import { UPDATE_HOMESALE_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getHomesaleInfo, postHomesaleInfo, updateHomesaleInfo } from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const PreferredAgentCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { isReadOnly } = props;
  const homesaleInfo = props.homesale ? props.homesale.homesaleInfo : null;

  // const brokerMatch = useMemo(
  //   () => brokerAgents?.find(b => b.agentId === (homesaleInfo?.preferredAgentId ?? null)),
  //   [brokerAgents, homesaleInfo]
  // );

  // const brokerAgentSearchInfo = {
  //   searchingColumns: [
  //     { name: 'agentId', title: 'Id' },
  //     { name: 'firstName', title: 'Agent Name' },
  //     { name: 'companyName', title: 'Company Name' },
  //     { name: 'citiesServed', title: 'City' }
  //   ],
  //   searchingColumnExtensions: [
  //     { name: 'agentId', width: 100 },
  //     { columnName: 'firstName', width: 200 },
  //     { columnName: 'companyName', width: 300 },
  //     { columnName: 'citiesServed', width: 150 }
  //   ],
  //   searchingRows: brokerAgents,
  //   nameKey: 'firstName',
  //   idKey: 'agentId'
  // };

  const preferredAgentTabs = [{ header: 'Preferred Agent', order: 1, iconPath: ['fas', 'user'] }];

  const preferredAgentSummaries = [
    {
      header: 'Has Preferred Agent',
      accessorKey: 'hasPreferredAgent',
      type: 'checkbox',
      required: false,
      value: homesaleInfo?.hasPreferredAgent || false,
      tab: 1
    },
    { header: 'Preferred Agent Name', accessorKey: 'preferredAgentName', type: 'text', required: false, value: homesaleInfo ? homesaleInfo.preferredAgentName : '', tab: 1,
        showWhen: () => {
            return homesaleInfo && homesaleInfo.hasPreferredAgent === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.hasPreferredAgent === true;
        }
    },
    { header: 'Preferred Agency', accessorKey: 'preferredAgency', type: 'text', required: false, value: homesaleInfo ? homesaleInfo.preferredAgency : '', tab: 1,
      showWhen: () => {
            return homesaleInfo && homesaleInfo.hasPreferredAgent === true;
        },
        showWhenModal: ({ values }) => {
            return values && values.hasPreferredAgent === true;
        }
     },
     { header: 'Preferred Agency Email', accessorKey: 'preferredAgencyEmail', type: 'text', required: false, value: homesaleInfo ? homesaleInfo.preferredAgencyEmail : '', tab: 1,
      showWhen: () => {
            return homesaleInfo && homesaleInfo.hasPreferredAgent === true;
          },
         showWhenModal: ({ values }) => {
            return values && values.hasPreferredAgent === true;
        }
    },
    { header: 'Preferred Agency Phone', accessorKey: 'preferredAgencyPhone', type: 'text', required: false, value: homesaleInfo ? homesaleInfo.preferredAgencyPhone : '', tab: 1,
      showWhen: () => {
            return homesaleInfo && homesaleInfo.hasPreferredAgent === true;
          },
         showWhenModal: ({ values }) => {
            return values && values.hasPreferredAgent === true;
        }
    }

    // {
    //   header: 'Preferred Agent',
    //   accessorKey: 'preferredAgentId',
    //   type: 'advanced-search', 
    //   searchInfo: brokerAgentSearchInfo,
    //   nameKey: 'agentName',
    //   nameValue: brokerMatch ? `${brokerMatch.firstName} ${brokerMatch.lastName}` : '',
    //   required: false,
    //   value: homesaleInfo?.preferredAgentId,
    //   tab: 1
    // },
  ];

  const updateFields = async (tab, values) => {
      setIsLoading(true);
  
      let newValues = { ...homesaleInfo };

      newValues.hasPreferredAgent = values.hasPreferredAgent ? true : false;
      newValues.preferredAgentName = values.preferredAgentName || '';
      newValues.preferredAgency = values.preferredAgency || '';
      newValues.preferredAgencyEmail = values.preferredAgencyEmail || '';
      newValues.preferredAgencyPhone = values.preferredAgencyPhone || '';
  
      const resp = await props.updateHomesaleInfo(newValues);
      if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
        props.showToast('Failed to update homesale info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        await props.getHomesaleInfo(homesaleInfo?.authorizationFileId);
        setIsLoading(false);
        return true;
      }
      
    };

  return (
    <EditableCard
      tabs={preferredAgentTabs}
      summaries={preferredAgentSummaries}
      numColumns={2}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );
};

const mapStateToProps = state => {
  const { homesalePropertyTypes } = state.enumerations.allEnums;
  return {
    typeOfHomesEnum: homesalePropertyTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    updateHomesaleInfo,
    postHomesaleInfo,
    showToast,
    getHomesaleInfo
  })
)(PreferredAgentCard);